import {useEffect, useRef} from 'react';

interface SimpleKakaoMapProps {
    address: string;
    addressDetail?: string;
}

export default function SimpleKakaoMap({address, addressDetail}: SimpleKakaoMapProps) {
    const mapContainer = useRef<HTMLDivElement>(null);
    const mapInstance = useRef<any>(null);

    useEffect(() => {
        if (!address) return;

        if ((window as any).kakao?.maps) {
            initMap();
            return;
        }

        const script = document.createElement('script');
        script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=${process.env.REACT_APP_KAKAO_API_KEY}&autoload=false&libraries=services`;
        script.async = true;

        script.onload = () => {
            (window as any).kakao.maps.load(() => {
                initMap();
            });
        };

        document.head.appendChild(script);

        return () => {
            if (document.head.contains(script)) {
                document.head.removeChild(script);
            }
        };
    }, [address]);

    const initMap = () => {
        if (!mapContainer.current || !address) return;

        const kakao = (window as any).kakao;
        const geocoder = new kakao.maps.services.Geocoder();

        // 주소로 좌표 검색
        geocoder.addressSearch(address, (result: any, status: any) => {
            if (status === kakao.maps.services.Status.OK) {
                const coords = new kakao.maps.LatLng(result[0].y, result[0].x);

                const options = {
                    center: coords,
                    level: 5,
                };

                mapInstance.current = new kakao.maps.Map(mapContainer.current, options);

                // 마커 표시
                const marker = new kakao.maps.Marker({
                    map: mapInstance.current,
                    position: coords
                });

                // 인포윈도우 표시
                const infowindow = new kakao.maps.InfoWindow({
                    content: `<div style="padding:5px;font-size:12px;width:200px;">
                        <strong>${address}</strong><br/>
                        ${addressDetail || ''}
                    </div>`
                });

                infowindow.open(mapInstance.current, marker);
            } else {
                console.error('주소 검색 실패');
            }
        });
    };

    return (
        <div
            ref={mapContainer}
            style={{
                width: '100%',
                height: '300px',
                position: 'relative'
            }}
        />
    );
}